import { H3, H4 } from '@dnb/eufemia';
import styled from '@emotion/styled';

import { mq } from './Api.global.styles';

export const StyledApiDocumentationPage = styled.div`
  grid-template-columns: auto;
  display: grid;
  background-color: ${(props) => props?.theme?.colors.backgroundDocumentation};

  .__left {
    background-color: ${(props) => props?.theme?.colors.backgroundMenu};
    border-right: 1px solid var(--color-black-8);
    display: none;

    &.active {
      position: fixed;
      top: 4rem;
      left: 0;
      display: inline-block;
      width: 100%;
      height: calc(100vh - 4rem);
      z-index: 100001;

      .sticker {
        float: left;
      }

      li.active {
        background-color: inherit;
      }
    }

    ${mq['large']} {
      display: inline-block;
    }

    .sticker {
      float: right;
      position: sticky;
      top: 4rem; // NavigationBar height

      display: flex;
      flex-direction: column;
      gap: 2rem;

      padding-top: 2rem;
      width: 22rem;
      max-height: calc(100vh - 4rem);
    }

    .scroll-content {
      flex: 1;
      overflow-y: auto;
    }

    ul {
      margin: 0;
      padding: 0;

      &.introduction {
        margin-bottom: var(--spacing-small);
      }

      li {
        color: ${(props) => props?.theme?.colors.menuLinks};

        list-style: none;
        font-size: var(--font-size-small);

        a {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 0.5rem;

          padding: 1rem 1.5rem 1rem 2rem;

          cursor: pointer;
          text-decoration: none;
          color: ${(props) => props?.theme?.colors.menuLinks};

          &.dnb-anchor {
            padding: 0;
            color: inherit;
          }
        }

        span {
          display: none;

          ${mq['large']} {
            display: block;
          }
        }

        &.active {
          background-color: ${(props) => props?.theme?.colors.menuLinksActive};

          a {
            font-weight: var(--font-size-medium);
          }
        }

        &:hover {
          background-color: ${(props) => props?.theme?.colors.menuLinksHover};
        }

        &.sub {
          padding-left: var(--spacing-large);
          .operator {
          }
        }

        a > div:last-child {
          width: 70%;
        }

        &.header {
          display: block;
          padding: var(--spacing-small) var(--spacing-large);
          text-transform: uppercase;
          color: ${(props) => props?.theme?.colors.menuSecondary};
          &:hover {
            background-color: transparent;
          }
        }
      }
    }
  }

  .content {
    width: auto;
    max-width: 960px;
    padding-bottom: calc(var(--spacing-xx-large) + var(--spacing-xx-large));
    scroll-behavior: auto;
    overflow-wrap: break-word;
    word-break: break-word;
    min-width: 0;

    ${mq['small']} {
      margin: 0 var(--spacing-medium);
    }

    ${mq['medium']} {
      margin: 0 var(--spacing-large);
    }

    .code {
      width: 100%;
      display: inline-grid;
    }

    .download {
      margin-top: var(--spacing-x-large);
      margin-bottom: var(--spacing-medium);

      span {
        margin-right: var(--spacing-xx-small);
      }
      a {
        cursor: pointer;
      }
    }
    h1 {
      font-size: var(--font-size-x-large);
      line-height: var(--line-height-basis);
      margin: var(--spacing-x-large) 0 var(--spacing-large) 0;
      font-weight: var(--font-weight-medium);
    }
    #introduction {
      p {
        margin-top: var(--spacing-large);
        margin-bottom: 0;
        font-size: var(--font-size-basis);
      }
    }
  }
`;

export const H3S = styled(H3)`
  font-size: var(--font-size-large);
  line-height: var(--line-height-lead);
  margin: var(--spacing-large) 0 var(--spacing-small) 0 !important;
`;

export const H4S = styled(H4)`
  font-size: var(--font-size-medium);
  text-transform: capitalize;
  line-height: var(--line-height-basis);
  margin: var(--spacing-large) 0 var(--spacing-small) 0 !important;
`;
